// extracted by mini-css-extract-plugin
export default {"main":"uploadImagesNew_main__Im7bw","title":"uploadImagesNew_title__M0Sa8","container":"uploadImagesNew_container__IvboX","uploadSection":"uploadImagesNew_uploadSection__hZsA5"};